const LogoIcon = () => {
  return <img height={41} width={41} src={`/svg/logo.svg`} alt="logo" />;
};

export default LogoIcon;
